import { render, staticRenderFns } from "./task-priority-select.vue?vue&type=template&id=5df04edd"
import script from "./task-priority-select.vue?vue&type=script&lang=js"
export * from "./task-priority-select.vue?vue&type=script&lang=js"
import style0 from "./task-priority-select.vue?vue&type=style&index=0&id=5df04edd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports